export default () => ({
	selected_variant: null,
	fixHeight() {
		if (window.innerWidth > 767) {
			this.$el.style.height = `${this.$el.clientHeight}px`;
			this.$el.classList.add('active');
		}
	},

	unfixHeight() {
		if (window.innerWidth > 767) {
			this.$el.style.height = `${this.$el.clientHeight}px`;
			this.$el.classList.remove('active');
		}
	},

	async addCartForProductCard(config, mobile) {
		let addToCartForm = this.$el.closest('form');
		if (mobile) {
			const parent = this.$el.closest('.product-card');
			addToCartForm = parent.querySelector('form');
		}
		let formData = new FormData(addToCartForm);
		formData.set('sections', 'cart-main,cart-drawer-sections');
		const quantity = this.$el.previousElementSibling.value;

		const response = await fetch(window.routes.cartAdd + '.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Access-Control-Allow-Origin': 'no-cors',
			},
			body: formData,
		});
		const data = await response.json();

		if (response.ok) {
			this.$dispatch('cart-update', { cartData: data });
		}

		this.gtmAddToCart(config, Number(quantity));
	},

	gtmAddToCart(config, item_quantity) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: config.price,
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: config.sku,
							sku: config.sku,
							name: config.title,
							price: config.price,
							brand: 'Brooklyn Soap Company',
							category: config.category,
							quantity: item_quantity,
						},
					],
				},
			},
			items: [{ id: config.sku, google_business_vertical: 'retail' }],
		});
	},

	initSlider() {
		const sliderElement = this.$el.querySelector('.slider');
		if (!sliderElement || window.innerWidth > 767) return;
		const options = {
			slidesPerView: 1,
			slidesPerMove: 1,
			pagination: {
				el: this.$el.querySelector('.swiper-pagination'),
				type: 'bullets',
				clickable: true,
			},
		};

		const slider = new window.Swiper(sliderElement, options);
	},

	async openQuickBuy(handle) {
		const id = Number(this.$el.dataset.id);
		if (this.selected_variant) {
			this.$dispatch('open-quick-buy', { data: this.selected_variant });
		} else {
			const url = `${window.Shopify.routes.root}products/${handle}?view=get-product-json`;
			const response = await fetch(url);
			if (response.status !== 200) return;
			const product = await response.json();

			const data = {
				title: product.title,
				featured_image: product.featured_image,
				image_alt: product.featured_media.alt,
				url: product.url,
				selected_variant: product.variants.find((variant) => variant.id === id),
				variants: product.variants,
			};
			this.selected_variant = data;
			this.$dispatch('open-quick-buy', { data: this.selected_variant });
		}
	},

	init() {
		this.initSlider();
	},
});
